module.exports = __webpack_public_path__ + "media/images/pages/ai/pocstock-ethical-ai-face-4-3bcccc1ba736af5959990dec0d7678f7.png";